(() => {
  function initialise(gallery) {
    if (gallery.dataset.refinedGalleryReady) return;
    gallery.dataset.refinedGalleryReady = 'true';
    const items = [...gallery.querySelectorAll('[data-media-item]')];
    const thumbnails = [...gallery.querySelectorAll('[data-media-thumbnail]')];
    const root = gallery.closest('[data-product-root]');
    const thumbnailStrip = gallery.querySelector('.product-gallery__thumbnails');
    const panelGallery = root.querySelector('[data-panel-gallery]');
    const viewer = gallery.querySelector('[data-gallery-viewer]');
    const fullImage = gallery.querySelector('[data-gallery-full-image]');
    const counter = gallery.querySelector('[data-gallery-count]');
    let opener;
    const selectedIndex = () => Math.max(0, items.findIndex(item => !item.hidden));
    const update = () => {
      if (counter) counter.textContent = `${selectedIndex() + 1} / ${items.length}`;
    };
    const step = direction => {
      const index = (selectedIndex() + direction + items.length) % items.length;
      thumbnails[index]?.click();
      thumbnails[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => step(-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => step(1));
    const controls = gallery.querySelector('.product-gallery__controls');
    if (controls) controls.hidden = false;
    const desktop = window.matchMedia('(min-width: 981px)');
    const placeThumbnails = () => {
      if (!thumbnailStrip) return;
      if (desktop.matches) {
        panelGallery.append(thumbnailStrip);
        if (controls) panelGallery.append(controls);
        panelGallery.hidden = false;
      } else {
        gallery.append(thumbnailStrip);
        if (controls) gallery.append(controls);
        panelGallery.hidden = true;
      }
    };
    desktop.addEventListener('change', placeThumbnails);
    placeThumbnails();
    new MutationObserver(update).observe(gallery.querySelector('.product-gallery__stage'), { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    items.forEach(item => {
      const link = item.querySelector('a');
      if (!link) return;
      link.addEventListener('click', event => {
        if (!viewer?.showModal) return;
        event.preventDefault();
        opener = link;
        fullImage.src = link.href;
        fullImage.alt = link.querySelector('img')?.alt || 'Product image';
        viewer.showModal();
      });
    });
    gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => viewer.close());
    viewer?.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    thumbnailStrip?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const index = thumbnails.indexOf(event.target);
      if (index < 0) return;
      const next = thumbnails[(index + (event.key === 'ArrowRight' ? 1 : -1) + thumbnails.length) % thumbnails.length];
      next.focus({ preventScroll: true });
      next.click();
    });
    update();
  }
  document.querySelectorAll('.product-gallery--refined').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.product-gallery--refined').forEach(initialise));
})();
